export const SCHEDULER = 'Scheduler';

export const DICT_DEFAULT_RESOURCE_TEXT = {
    'SELFSCHEDULER_NEXT': "Next",
    'SELFSCHEDULER_BACK': "Back",
    'SELFSCHEDULER_SUBMIT': "Submit",
    'SELFSCHEDULER_POWEREDBYTEXT': "powered by ",
    'SELFSCHEDULER_PRIVACYPOLICYTEXT': "privacy policy",
    'SELFSCHEDULER_NOAPPOINTMENTSFORSELECTEDDATE': "Sorry, there are no appointments available for the selected date",
    'SELFSCHEDULER_FOOTER_LOGO': "/v24/veedesk/themes/master/images/logo-black.png",
    'SELFSCHEDULER_APPOINTMENTTYPE_HEADER': "Choose a reason for your appointment: ",
    'SELFSCHEDULER_APPOINTMENTTYPE_ARIA_LABEL': "Appointment Types, Use the arrow keys to navigate between appointment types and press Enter or Space to select",
    'SELFSCHEDULER_HIERARCHYCATEGORYDATA_NOTAVAILABLE': "Hierarchical appointment categories are configured to display but no categories have been configured.",
    'SELFSCHEDULER_DEFAULTSELECTOPTION': "--Please Select--",
    'SELFSCHEDULER_SELECTCATEGORY': "Please select the appointment category",
    'SELFSCHEDULER_ERRORONCALENDAR': "Error while loading calendar",
    "SELFSCHEDULER_CALENDARPAGETITLE": "Thank You for your interest in <span class='body2'>{0}</span>.",
    "SELFSCHEDULER_CALENDARPAGEINSTRUCTIONS": "Please choose a date and time:",
    "SELFSCHEDULER_CALENDARPAGEINSTRUCTIONS_WITH_LOCATION": "Please choose a date and time for your selected location: <span class='body2'>{0}</span>",
    "SELFSCHEDULER_CALHEADER_INSTRUCTIONS_ARIA_LABEL": "Calendar navigation. Use left and right arrow keys to move between months",
    "SELFSCHEDULER_CALBODY_INSTRUCTIONS_ARIA_LABEL": "Calendar dates. Use arrow keys to navigate between dates, Enter or Space to select a date. Press Tab to return to month navigation.",
    "SELFSCHEDULER_CURRENT_MONTH_ARIA_LABEL": "Current Month, {0}",
    "SELFSCHEDULER_NEXT_MONTH_ARIA_LABEL": "Next Month, {0}",
    "SELFSCHEDULER_PREVIOUS_MONTH_ARIA_LABEL": "Previous Month",
    'SELFSCHEDULER_CALWEEK_ABR_MONDAY': "MON",
    'SELFSCHEDULER_CALWEEK_ABR_TUESDAY': "TUE",
    'SELFSCHEDULER_CALWEEK_ABR_WEDNESDAY': "WED",
    'SELFSCHEDULER_CALWEEK_ABR_THURSDAY': "THU",
    'SELFSCHEDULER_CALWEEK_ABR_FRIDAY': "FRI",
    'SELFSCHEDULER_CALWEEK_ABR_SATURDAY': "SAT",
    'SELFSCHEDULER_CALWEEK_ABR_SUNDAY': "SUN",
    'SELFSCHEDULER_LOCATIONPAGETITLE' : "Thank You for your interest in <span class='body2'>{0}</span>",
    "SELFSCHEDULER_LOCATIONPAGEINSTRUCTIONS": "Please choose a location:",
    "SELFSCHEDULER_SELECTED_TIMESLOT_INSTRUCTIONS": "<span class='body2'>Selected Date: {0}</span>",
    'SELFSCHEDULER_MAXALLOWEDDATE': "45",
    'SELFSCHEDULER_MISSING_APPOINTMENTTYPE': "Please select Appointment Type!!",
    'SELFSCHEDULER_CUSTOMERINFO_HEADER': "Enter your contact information to book your appointment:",
    'SELFSCHEDULER_REQUIRED': "*",
    'SELFSCHEDULER_SHOW_GDPR': "0",
    'SELFSCHEDULER_GDPR_CONTENT': "By clicking the below, I agree to the Vee24 <a href='https://www.vee24.com/privacy-policy' target='_blank'>Privacy Policy</a> and <a href='https://www.vee24.com/terms-of-use/' target='_blank'>Terms and Conditions</a>.",
    'REQUIRED_VALIDATION_ERROR': "{0} is Required",
    'SELFSCHEDULER_ERROR_RESPONSE': "Not able to book an appointment. Please try again.",
    'SELFSCHEDULER_SUCCESS_RESPONSE': "You are booked </br> for an appointment </br> on {0} </br> at {1}.",
    'SELFSCHEDULER_FORM_LOAD_ERROR': "<span class='body2'>Unable to load form</span>",
    'SELFSCHEDULER_APPOINTMENT_TYPES_LOAD_ERROR': "<span class='body2'>Unable to load appointment types</span>",
    'SELFSCHEDULER_LOCATION_CONFIRMATION_LABEL': 'Appointment Location',
    'SELFSCHEDULER_NOAPPOINTMENTSFORTYPE': 'Sorry, it appears there are no appointments available for the selected appointment type or location',
    'SELFSCHEDULER_STEP_TITLE_CATEGORY': 'Appointment Category',
    'SELFSCHEDULER_STEP_TITLE_APPOINTMENT_TYPE': 'Appointment Type',
    'SELFSCHEDULER_STEP_TITLE_LOCATION': 'Location',
    'SELFSCHEDULER_STEP_TITLE_CALENDAR': 'Schedule',
    'SELFSCHEDULER_STEP_TITLE_REGISTRATION': 'Contact Information',
    'SELFSCHEDULER_STEP_TITLE_CONFIRMATION': 'Confirmation',
};

export const DICT_ARIA_RESOURCE_TEXT = {
    'SELFSCHEDULER_ARIA_PHONE_NUMBER': 'Telephone Number',
    'SELFSCHEDULER_ARIA_EMAIL_ADDRESS': 'Email Address',
    'SELFSCHEDULER_ARIA_PHONE_NUMBER_INSTRUCTIONS': 'Please Enter A Phone Number',
    'SELFSCHEDULER_ARIA_TIMESLOT_INSTRUCTIONS': 'Please Select A Timeslot',
    'SELFSCHEDULER_ARIA_FORM_FIELD_REQUIRED': 'Required'
}

/**
 * Triggered by a user Action, View or other non-interaction event
 ***/
export const EventCategories = {
    View : 'View',
    NonInteraction : 'Non-Interaction',
    Action : 'Action'
}

/**
 * ** Identifies the triggered event and is used to differentiate between different actions,
 * for e.g. viewing or closing a panel, clicking on a video, or responding to a Call-to-action.
**/

export const EventTypes = {
    /*** Panel is rendered and visible to the customer */
    PanelView : 'User-Panel-View',
    /*** Panel state has changed, such as {@link EventValues.Show | EventValues.Hide} or {@link EventValues.Change}  */
    PanelStateChange : 'Panel-State-Change',
    Timeout : 'Timeout',
    Success : 'Success',
    Close : 'Close',
    /*** A Call to action has been clicked on by the customer, such as a Nudge accept button or a connection method */
    CTAClick : 'CTA-Click',
    /*** Click on an in page link, minor UI component ***/
    Click : 'Click',
    /*** For e.g. legal panel ***/
    Hide : 'Hide',
    Show : 'Show',
    Error : 'Error'
}

/**
 * The value of an event action - used to clearly identify the individual event
 **/
export const EventValues = {
    /** The scheduler CTA button was clicked the user */
    Scheduler : 'Scheduler',
    /** The Next button was clicked the user */
    Next : 'Next',
    /** The Back button was clicked the user */
    Back : 'Back',
    /** The Powered-By-Vee24 link was clicked by the user */
    PoweredByVee24 : 'Powered-By-Vee24',
    /** The terms and conditions link was clicked by the user */
    TermsAndConditions : 'Terms-and-Conditions',
    /** The form submit button was clicked by the user */
    FormSubmit : 'Form-Submit',
    /** The Close button was clicked on by the user -> Abandonment */
    Close : 'Close',
    Show : 'Show',
    Hide : 'Hide',
    NoAppointmentsForTypeAvailable: 'No-Apts-for-Type',
    NoAppointmentsForDateAvailable: 'No-Apts-for-Date',
    AppointmentCreated: 'Appointment-Created'
}
export const ModalStepsLabel = {
    appointmentSelectionStep: 'appointment',
    appointmentLocationStep: 'location',
    appointmentTimeStep : 'calendar',
    appointmentRegistrationStep: 'registration',
    appointmentConfirmationStep: 'submit-response'
}

export const HIERARCHY_EVENTS = {
    categorySelected: "category-selected",
    categoryDeSelected: "category-deselected",
    categoryNotFound: "category-not-found",
};

export const APPOINTMENT_TYPE_SELECTION_EVENTS = {
    appointmentTypeSelected: "appointment-type-selected"
};

export const LOCATION_EVENTS = {
    locationSelected: "location-selected",
};

export const TIMESLOT_EVENTS = {
    timeslotSelected: "timeslot-selected",
};

export const APPOINTMENT_FORM_SUBMIT_ERRORS = {
    validationError : -1,
    typeError : 1, 
    networkRequestError: 2
};

export const MODAL_STEPS = {
    appointmentSelectionStep    : 1,
    appointmentLocationStep     : 2,
    appointmentTimeStep         : 3,
    appointmentRegistrationStep : 4,
    appointmentConfirmationStep : 5
};

export const SCHEDULER_RESPONSE_ERROR_TRANSLATION_KEY = {
  "SELFSCHEDULER_ERROR_PARAMETER_RESPONSE"  : 1, 
  "SELFSCHEDULER_ERROR_AGENT_RESPONSE"      : 2, 
  "SELFSCHEDULER_ERROR_CUSTOMER_RESPONSE"   : 3, 
  "SELFSCHEDULER_ERROR_MAIL_RESPONSE"       : 4  
};

export const NAVIGATION_EVENTS = {
    goNext: "go-next",
    goBack: "go-back",
};

export const ARROW_SVG_PATHS = {
    Back: "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z",
    Next: "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z",
};
